export const USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST';
export const USER_SIGNIN_SUCESS = 'USER_SIGNIN_SUCESS';
export const USER_SIGNIN_ERROR = 'USER_SIGNIN_ERROR';
export const USER_SIGNIN_RESET = 'USER_SIGNIN_RESET';
export const USER_SIGNOUT = 'USER_SIGNOUT';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCESS = 'CREATE_USER_SUCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';
export const CREATE_USER_RESET = 'CREATE_USER_RESET';

export const GET_USER_PROJECT_REQUEST = 'GET_USER_PROJECT_REQUEST';
export const GET_USER_PROJECT_SUCESS = 'GET_USER_PROJECT_SUCESS';
export const GET_USER_PROJECT_ERROR = 'GET_USER_PROJECT_ERROR';

export const SEARCH_USERS_REQUEST = 'SEARCH_USERS_REQUEST';
export const SEARCH_USERS_SUCESS = 'SEARCH_USERS_SUCESS';
export const SEARCH_USERS_ERROR = 'SEARCH_USERS_ERROR';

export const SEARCH_COMPANY_USERS_REQUEST = 'SEARCH_COMPANY_USERS_REQUEST';
export const SEARCH_COMPANY_USERS_SUCESS = 'SEARCH_COMPANY_USERS_SUCESS';
export const SEARCH_COMPANY_USERS_ERROR = 'SEARCH_COMPANY_USERS_ERROR';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCESS = 'UPDATE_USER_SUCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const UPDATE_USER_RESET = 'UPDATE_USER_RESET';

export const RECOVER_PASSWORD_USER_REQUEST = 'RECOVER_PASSWORD_USER_REQUEST';
export const RECOVER_PASSWORD_USER_SUCESS = 'RECOVER_PASSWORD_USER_SUCESS';
export const RECOVER_PASSWORD_USER_ERROR = 'RECOVER_PASSWORD_USER_ERROR';
export const RECOVER_PASSWORD_USER_RESET = 'RECOVER_PASSWORD_USER_RESET';

export const SEARCH_SPECIFY_USER_REQUEST = 'SEARCH_SPECIFY_USER_REQUEST';
export const SEARCH_SPECIFY_USER_SUCESS = 'SEARCH_SPECIFY_USER_SUCESS';
export const SEARCH_SPECIFY_USER_ERROR = 'SEARCH_SPECIFY_USER_ERROR';

export const UPDATE_ADMIN_USER_REQUEST = 'UPDATE_ADMIN_USER_REQUEST';
export const UPDATE_ADMIN_USER_SUCESS = 'UPDATE_ADMIN_USER_SUCESS';
export const UPDATE_ADMIN_USER_ERROR = 'UPDATE_ADMIN_USER_ERROR';
export const UPDATE_ADMIN_USER_RESET = 'UPDATE_ADMIN_USER_RESET';

export const RESEND_EMAIL_USER_REQUEST = 'RESEND_EMAIL_USER_REQUEST';
export const RESEND_EMAIL_USER_SUCESS = 'RESEND_EMAIL_USER_SUCESS';
export const RESEND_EMAIL_USER_ERROR = 'RESEND_EMAIL_USER_ERROR';
export const RESEND_EMAIL_USER_RESET = 'RESEND_EMAIL_USER_RESET';
